import { Stack } from '@chakra-ui/react';
import DashboardCard from '@components/atoms/DashboardCard';
import { StaticImageData } from 'next/image';
import CardHeading from './CardHeading';
import PlanDetails from './PlanDetails';
import { formatUtcDateToDateString } from '@utils/formatDate';

interface Props {
  title: string;
  icon: StaticImageData;
  activePlan: any;
  futurePlan: any;
}

function PlanDashboardCard({ title, icon, activePlan, futurePlan }: Props) {
  return (
    <DashboardCard>
      <Stack>
        <CardHeading title={title} src={icon} alt={title} />
        {activePlan ? <PlanDetails title="Current Coverage" plan={activePlan} /> : null}
        {futurePlan ? (
          <PlanDetails
            title={`Future Coverage – Effective ${formatUtcDateToDateString(futurePlan.effective_date)}`}
            plan={futurePlan}
          />
        ) : null}
      </Stack>
    </DashboardCard>
  );
}

export default PlanDashboardCard;
